import React, { useEffect, useState } from "react";
import ProductList from "../components/ProductList";
import CategoryList from "../components/CategoryList";
import BestSellerProducts from "../components/BestSellerProducts";
import LatestProducts from "../components/LatestProducts";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import BlockList from "./BlogList";


const Homepage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = [
    "https://www.butterflyassets.online/crowsporesslider1.webp",
    "https://www.butterflyassets.online/crowsporesslider2.webp",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 3000); // Change slide every 3 seconds
    return () => clearInterval(interval);
  }, [images.length]);
  const [products, setProducts] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const navigate = useNavigate();
  const heroImage = products.length > 0 ? products[0].picture : "";

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          "https://herokuapigate.etasick.workers.dev/api/products/store/6769d5af594286288e1ed0a3"
        );
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="homepage">
      <Helmet>
                <title>Mushroom Spores for sale|spore prints and spore swabs,Grow Bags|Crow Spores
                </title>
                <meta name="description" content="Crow Spores offers psilocybe cubensis spores  in many options such mushroom spore syringes,spore prints,spore swabs.Mushroom cultivations kits also available."/>
            </Helmet>
      <div className="relative w-full h-80 overflow-hidden">
  <div
    className="absolute inset-0 flex transition-transform duration-1000"
    style={{
      transform: `translateX(-${currentSlide * 100}%)`,
    }}
  >
    {images.map((src, index) => (
      <div
        key={index}
        className="relative w-full h-80 flex-shrink-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${src})`,
        }}
      >
        {/* Shop Now Button */}
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2">
          <button
            className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-md hover:bg-blue-700"
            onClick={() => {
              window.location.href = "/shop";
            }}
          >
            Shop Now
          </button>
        </div>
      </div>
    ))}
  </div>

  {/* Previous Button */}
  <button
    className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
    onClick={() =>
      setCurrentSlide((prev) => (prev - 1 + images.length) % images.length)
    }
  >
    &#8249;
  </button>

  {/* Next Button */}
  <button
    className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
    onClick={() => setCurrentSlide((prev) => (prev + 1) % images.length)}
  >
    &#8250;
  </button>
</div>

      {/* Hero Section */}
      <h1> Our mushroom spores</h1>
      <ProductList products={products}/>
      <CategoryList/>
      <BlockList/>
       {/* Promotional Section */}
      <section className="py-16 bg-gray-100 text-center">
        <h2 className="text-3xl font-bold mb-6"> Why you should choose us?</h2>
        <div className="flex flex-wrap justify-center space-x-6">
          <div className="w-full md:w-1/3 p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">We have mushroom spores in several forms; Mushroom spores syringes,spore prints,spore swabs and mushroom growing bags.</h3>
            <p className="text-gray-600">
              Choose from the huge selection of the best mushroom spores strains.
            </p>
          </div>
          <div className="w-full md:w-1/3 p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">We deliver discreetly to all states.</h3>
            <p className="text-gray-600">
              Are you a first time customer? we have amazing deals for you at checkout.Buy Mushroom spores in USA .
            </p>
          </div>
          <div className="w-full md:w-1/3 p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold">Delivery to all 50 states</h3>
            <p className="text-gray-600">
              Subscribe to ournewsletter so that you do not miss any discounts.
            </p>
          </div>
        </div>
      </section>
      <div className="card max-w-sm mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
  <div className="p-6">
    <h5 className="text-xl font-semibold text-gray-800 mb-3">What is Our Mission?</h5>
    <p className="text-gray-600 mb-4">
    The sale of cubensis spores is legal in 47 states in the U.S., although there are exceptions in California, Georgia, and Idaho. All spore syringes sold on this website  are intended for research purposes only.
    </p>
    
    <p className="text-gray-600 mb-4">
      We offer  a huge collection of mushroom spore strains which you chose from.
    </p>
    <p className="text-gray-600">
    </p>
  </div>
</div>

      {/* FAQ Section */}
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold text-center mb-6">New to our website? Check out the FAQ section to start.</h2>
        <div>
          {[
            {
              question: "How many strains of mushroom spores are available?",
              answer:
                "We have over 50 strains of mushroom spores available.make your choice in the products page.",
            },
            {
              question: "What materials can be used as a substrate for mushroom cultivation?",
              answer:
                "Common substrates include straw, sawdust, wood chips, coffee grounds, and composted manure. The choice depends on the mushroom species.",
            },
            {
              question: "How long does it take for mushrooms to grow?",
              answer:
                "Depending on the species, mushrooms can take anywhere from a few days to several weeks to mature after the mycelium has fully colonized the substrate.",
            },
            {
              question: "What are the environmental benefits of mushroom farming?",
              answer:
                "Mushroom farming can utilize agricultural waste as substrate, reducing waste and promoting sustainability. Additionally, mushrooms have potential in bioremediation.",
            },
          ].map((faq, index) => (
            <div key={index} className="border border-gray-300 rounded-md mb-4">
              <button
                onClick={() => toggleAccordion(index)}
                className="flex justify-between w-full p-4 text-lg font-semibold focus:outline-none"
              >
                {faq.question}
                <span>{activeAccordion === index ? "-" : "+"}</span>
              </button>
              {activeAccordion === index && (
                <div className="p-4 text-gray-600">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Homepage;
